import { type FC } from 'react'
import { Status } from 'shared/ui'
import styles from './styles.module.scss'

interface TrendData {
  percent?: number
  absolute?: number
  isUp?: boolean
}

interface TrendLabelProps {
  trend: TrendData
  displayMode?: 'percent' | 'absolute'
}

export const TrendLabel: FC<TrendLabelProps> = ({ trend, displayMode = 'absolute' }) => {
  const title = displayMode === 'percent' ? `${trend.percent}%` : `${trend.absolute}`

  return (
    <Status
      emphasis='high'
      size='custom-low'
      rightIconSize={16}
      title={title}
      intent={trend.isUp ? 'positive' : 'negative'}
      icon={trend.isUp ? 'arrowUp' : 'arrowDown'}
      typographyProps={{
        variant: 'body-xs-medium',
        ariaLabel: 'TrendValue',
        className: styles.trendLabel,
      }}
    />
  )
}
